import { render, staticRenderFns } from "./MyWalletChooseWallet.vue?vue&type=template&id=7addbb7f&scoped=true"
import script from "./MyWalletChooseWallet.vue?vue&type=script&lang=ts"
export * from "./MyWalletChooseWallet.vue?vue&type=script&lang=ts"
import style0 from "./MyWalletChooseWallet.vue?vue&type=style&index=0&id=7addbb7f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7addbb7f",
  null
  
)

export default component.exports